import { authSlice } from '@containers/Auth/slice';
import { combineSlices } from '@reduxjs/toolkit';
import { assessmentSlice } from '@containers/Assessment/slice';
import { meetingSlotsSlice } from '@containers/Scheduling/SlotBooking/slice';
import { candidateSlice } from '@containers/CandidateRegistration/slice';
import { asyncSlice } from '@containers/Assessment/AsyncPlayGround/slice';
import { paymentSlice } from '@containers/Payment/slice';
import { schedulingSlice } from '@containers/Scheduling/slice';
import { driveSlice } from '@containers/Drive/slice';
import { candidateAvailabilitySlice } from '@containers/CandidateAvailability/slice';
import { candidateProfileSlice } from '@containers/BiometricAuthentication/FaceAuth/slice';
import { standaloneFormSlice } from '../containers/Standalone/slice';
import { consentSlice } from '@containers/Consent/slice';
import { longFormSlice } from '@containers/Assessment/LongFormPlayGround/slice';
import { proviewSlice } from '@containers/Proview/slice';
import { appSlice } from '@containers/App/slice';
import { joinInterviewSlice } from '@containers/Scheduling/JoinInterview/slice';
import { jobSlice } from '@containers/JobDescription/slice';
import { publicAssessmentSlice } from '@containers/PublicAssessment/slice';
export default combineSlices({
    [authSlice.name]: authSlice.reducer,
    [assessmentSlice.name]: assessmentSlice.reducer,
    [meetingSlotsSlice.name]: meetingSlotsSlice.reducer,
    [candidateSlice.name]: candidateSlice.reducer,
    [asyncSlice.name]: asyncSlice.reducer,
    [paymentSlice.name]: paymentSlice.reducer,
    [schedulingSlice.name]: schedulingSlice.reducer,
    [driveSlice.name]: driveSlice.reducer,
    [standaloneFormSlice.name]: standaloneFormSlice.reducer,
    [candidateProfileSlice.name]: candidateProfileSlice.reducer,
    [consentSlice.name]: consentSlice.reducer,
    [longFormSlice.name]: longFormSlice.reducer,
    [proviewSlice.name]: proviewSlice.reducer,
    [appSlice.name]: appSlice.reducer,
    [joinInterviewSlice.name]: joinInterviewSlice.reducer,
    [jobSlice.name]: jobSlice.reducer,
    [publicAssessmentSlice.name]: publicAssessmentSlice.reducer,
    [candidateAvailabilitySlice.name]: candidateAvailabilitySlice.reducer,
});
